import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export const LocalLink = (props) => {
    const { i18n } = useTranslation();
    let { to, ...otherProps } = props;
    const localTo = "/" + i18n.languages[0] + to;
    return <Link to={localTo} {...otherProps} />
}